import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { CommonDashboardReport } from '@home/components/CommonDashboardReport';
import useSearchParams from '@gp/hooks/useSearchParams';
import { buriedPointPage, typeIdObj } from '@home/utils/buriedPoint';
import { dbiPageLogMes } from '@intelligence/utils/buriedPointCfg';

import '@intelligence/components/LazyReport/index.scss';

interface IDatalabReportConfig extends IBaseProps {
  gameCode: 'databrain' | (string & {});
  id: string;
  title: string;
}

interface IDatalabReportProps extends IBaseProps {}

const DatalabReport: React.FC<IDatalabReportProps> = (props) => {
  const { style, className } = props;

  const {
    gameCode: urlGameCode = 'databrain',
    id: urlId,
    title: urlTitle,
    pageTitle: urlPageTitle,
    pageLogConfigKey,
  } = useSearchParams();

  const pageLogConfig = dbiPageLogMes?.[pageLogConfigKey || 'pageIPLibrary'];

  const [report, setReport] = useState<IDatalabReportConfig>({
    gameCode: '',
    id: '',
    title: '',
  });

  const operationIpLibraryPageLog = (id: string) => {
    if (pageLogConfig) {
      buriedPointPage({ ...pageLogConfig, extInfo: id });
    }
  };

  useEffect(() => {
    setReport({
      ...report,
      gameCode: urlGameCode || '',
      id: urlId || '',
      title: urlPageTitle || urlTitle || '',
    });
    operationIpLibraryPageLog(urlId);
  }, [urlGameCode, urlId, urlTitle, urlPageTitle]);

  if (!report?.gameCode || !report?.id) return null;
  return (
    <CommonDashboardReport
      style={style}
      className={classnames('dbi-datalab-report', className)}
      system={typeIdObj.intelligence}
      gameCode={report.gameCode}
      dashboardId={report.id}
      dashboardName={report.title}
      reportInfo={{
        ...pageLogConfig,
        reportPageId: pageLogConfig?.pageId || '',
      }}
    />
  );
};

export default DatalabReport;
